import { tx } from "@/i18n/tx";
import { Banknote, Landmark, CalendarClock } from "lucide-react";
import DateField, { localToday, fmtCH } from "@/components/invoices/DateField";

const OPTIONS = [
  { k: "especes", l: tx("ui_paymentchoice.k1b3781"), Icon: Banknote },
  { k: "virement", l: tx("ui_paymentchoice.kd4f9b8"), Icon: Landmark },
  { k: "a_payer", l: tx("ui_paymentchoice.kd044d4"), Icon: CalendarClock },
];

export const paymentFor = (method, hints = {}) => ({
  method,
  date: method === "especes" ? hints.cashDate || localToday() : method === "virement" ? localToday() : hints.dueDate || "",
});

export const isPaymentValid = (p) => !!p?.method && !!p.date && (p.method !== "virement" || p.date <= localToday());

export const paymentPayload = (p) => ({
  payment_method: p.method,
  paid: p.method !== "a_payer",
  paid_date: p.method === "a_payer" ? null : p.date,
});

export default function PaymentChoice({ value, onChange, hints, testPrefix = "payment" }) {
  const pick = (k) => onChange(paymentFor(k, hints));
  return (
    <div className="space-y-2" data-testid={`${testPrefix}-choice`}>
      <div className="grid gap-2">
        {OPTIONS.map(({ k, l, Icon }) => {
          const on = value?.method === k;
          return (
            <button key={k} type="button" onClick={() => pick(k)} data-testid={`${testPrefix}-${k}`} aria-pressed={on}
              className={`min-h-14 px-4 rounded-2xl border-2 flex items-center gap-3 text-left font-semibold text-base transition-colors ${on ? "border-primary-c bg-primary-c text-white" : "border-c bg-white hover:border-primary-c/50"}`}>
              <Icon className="w-6 h-6 shrink-0" />{l}
            </button>
          );
        })}
      </div>
      {value?.method === "especes" && (
        <p className="text-sm text-text-secondary" data-testid={`${testPrefix}-cash-date`}>{tx("ui_paymentchoice.k1d3649")} <strong className="text-[var(--text)]">{fmtCH(value.date)}</strong> {tx("ui_paymentchoice.k7aed74")}</p>
      )}
      {value?.method === "virement" && (
        <div><span className="text-xs text-text-secondary block mb-1">{tx("ui_paymentchoice.kd97211")}</span>
          <DateField value={value.date} maxToday onChange={(d) => onChange({ ...value, date: d })} testId={`${testPrefix}-transfer-date`} /></div>
      )}
      {value?.method === "a_payer" && (
        <div><span className="text-xs text-text-secondary block mb-1">{tx("ui_paymentchoice.k1a2f43")}</span>
          <DateField value={value.date} autoOpen={!value.date} onChange={(d) => onChange({ ...value, date: d })} testId={`${testPrefix}-due-date`} /></div>
      )}
    </div>
  );
}
